import { render } from "./RecordsComponent.vue?vue&type=template&id=5dd554b6"
import script from "./RecordsComponent.vue?vue&type=script&lang=js"
export * from "./RecordsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__